<div class="mat-paginator-outer-container">
  <div class="mat-paginator-container">
    <div class="mat-paginator-range-actions">
      <button type="button"
              class="border mat-elevation-z mat-paginator-navigation-first"
              mat-mini-fab
              color=""
              (click)="firstPage()"
              [attr.aria-label]="_intl.firstPageLabel"
              [matTooltip]="_intl.firstPageLabel"
              [matTooltipDisabled]="_previousButtonsDisabled()"
              [matTooltipPosition]="'above'"
              [disabled]="_previousButtonsDisabled()"
              *ngIf="showFirstLastButtons">
        <mat-icon>first_page</mat-icon>
      </button>
      <button type="button"
              class="border mat-elevation-z mat-paginator-navigation-previous"
              mat-mini-fab
              color=""
              (click)="previousPage()"
              [attr.aria-label]="_intl.previousPageLabel"
              [matTooltip]="_intl.previousPageLabel"
              [matTooltipDisabled]="_previousButtonsDisabled()"
              [matTooltipPosition]="'above'"
              [disabled]="_previousButtonsDisabled()">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>

      <ng-container *ngFor="let pageItem of pages">
        <button [class]="'mat-elevation-z ' + (pageItem.index === pageIndex ? 'pe-none active' : '')"
                [class.fw-semibolde]="pageItem.index === pageIndex"
                type="button"
                mat-mini-fab
                [color]="pageItem.index === pageIndex ? 'primary' : ''"
                [attr.aria-label]="pageItem.index + 1"
                [ngSwitch]="pageItem.isEllipsis"
                (click)="goToPage(pageItem.index)">
          <mat-icon fontSet="design" *ngSwitchCase="true">more_horiz</mat-icon>
          <span class="d-inline-block" *ngSwitchDefault>{{pageItem.index + 1}}</span>
        </button>
      </ng-container>

      <button type="button"
              class="border mat-elevation-z mat-paginator-navigation-next"
              mat-mini-fab
              color=""
              (click)="nextPage()"
              [attr.aria-label]="_intl.nextPageLabel"
              [matTooltip]="_intl.nextPageLabel"
              [matTooltipDisabled]="_nextButtonsDisabled()"
              [matTooltipPosition]="'above'"
              [disabled]="_nextButtonsDisabled()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
      <button type="button"
              class="border mat-elevation-z mat-paginator-navigation-last"
              mat-mini-fab
              color=""
              (click)="lastPage()"
              [attr.aria-label]="_intl.lastPageLabel"
              [matTooltip]="_intl.lastPageLabel"
              [matTooltipDisabled]="_nextButtonsDisabled()"
              [matTooltipPosition]="'above'"
              [disabled]="_nextButtonsDisabled()"
              *ngIf="showFirstLastButtons">
        <mat-icon>last_page</mat-icon>
      </button>

      <div class="mat-paginator-range-label">
        {{_intl.getRangeLabel(pageIndex, pageSize, length)}}
      </div>
    </div>

    <div class="mat-paginator-page-size" *ngIf="!hidePageSize">
      <mat-form-field
                      *ngIf="_displayedPageSizeOptions.length > 1"
                      [appearance]="_formFieldAppearance!"
                      [color]="color"
                      class="mat-form-field-mini mat-paginator-page-size-select">
        <mat-select
                    [value]="pageSize"
                    [disabled]="disabled"
                    [aria-label]="_intl.itemsPerPageLabel"
                    (selectionChange)="_changePageSize($event.value)">
          <mat-option *ngFor="let pageSizeOption of _displayedPageSizeOptions" [value]="pageSizeOption">
            {{pageSizeOption}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div
           class="mat-paginator-page-size-value"
           *ngIf="_displayedPageSizeOptions.length <= 1">{{pageSize}}</div>

      <div class="mat-paginator-page-size-label">
        {{_intl.itemsPerPageLabel}}
      </div>
    </div>
  </div>
</div>